import React from 'react';
import { useNavigate } from 'react-router-dom';
import PublicLayout from '../components/PublicLayout';
import '../styles/public-homepage.css';
import heroImage from '../assets/CosmicRiver-small.jpeg';

const PublicHomePage = () => {
  const navigate = useNavigate();

  return (
    <PublicLayout>
      <div className="public-homepage">
      {/* Hero Section */}
      <section className="hero">
        <img 
          className="hero-background" 
          src={heroImage}
          alt="AI Governance"
          onError={(e) => {
            console.error('Hero image failed to load:', heroImage);
            e.currentTarget.style.display = 'none';
          }}
        />
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>AI with formal proofs, not plausible guesses.</h1>
          <p className="description">
            Fox River AI builds the governance and lifecycle tooling that lets you put autonomous AI behind consequential decisions — across agentic systems and ML pipelines — where every action is proven before it fires and runs where your data lives.
          </p>
          <p className="description">
            The market is filling with 'guardrails' that are themselves language models — a plausible guess checking a plausible guess. We build the opposite: a formal gate proves each consequential step against your declared rules before it executes, and every decision leaves an audit trail you can hand to a regulator.
          </p>
          <div className="cta-buttons">
            <button 
              className="cta-primary"
              onClick={() => navigate('/app')}
            >
              Learn More
            </button>
            <button 
              className="cta-secondary"
              onClick={() => navigate('/blog')}
            >
              Explore Our Insights
            </button>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="services-overview">
        <div className="container">
          <h2>Our Solutions</h2>
          <div className="services-grid">
            <div className="service-card">
              <h3>Agent Atlas</h3>
              <p>Govern agentic AI. Declares what every agent is, what it's allowed to do, and proves it before it acts, so autonomy never outruns oversight.</p>
            </div>
            <div className="service-card">
              <h3>Almanac</h3>
              <p>Automate and govern the ML lifecycle. Every consequential step — promote a model, deploy it, act on it — clears a formal proof before it takes effect, with an audit trail that doubles as compliance evidence.</p>
            </div>
            <div className="service-card">
              <h3>Noesis</h3>
              <p>The flagship. Governed clinical AI for documentation and revenue cycle, proving the approach under the hardest constraints: regulated data, fully on-premises, every inference traceable to its source.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Blog Section */}
      <section className="blog-section">
        <div className="container">
          <h2>Latest Insights</h2>
          <p>Stay updated with the latest in AI and business intelligence.</p>
          <button 
            className="blog-link"
            onClick={() => navigate('/blog')}
          >
            Read Our Blog
          </button>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section">
        <div className="container">
          <h2>Ready to Get Started?</h2>
          <p>Call today: (630) 940-8837</p>
          <p>Join businesses already using AI to gain competitive advantage.</p>
        </div>
      </section>
      </div>
    </PublicLayout>
  );
};

export default PublicHomePage;